'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _pack = require('../base/pack');

var _pack2 = _interopRequireDefault(_pack);

var _campaign = require('./campaign');

var _campaign2 = _interopRequireDefault(_campaign);

var _util = require('../util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pack = function (_BasePack) {
  (0, _inherits3.default)(Pack, _BasePack);

  function Pack(data) {
    (0, _classCallCheck3.default)(this, Pack);
    return (0, _possibleConstructorReturn3.default)(this, (Pack.__proto__ || (0, _getPrototypeOf2.default)(Pack)).call(this, data));
    // this.setLabelModel()
    // console.log('fffffffffffff', this.data)
    // this.setGiftCampaignsModel()
  }

  (0, _createClass3.default)(Pack, [{
    key: 'resetDefault',
    value: function resetDefault(data) {
      !data.labels && (data.labels = []);
      !data.giftPacks && (data.giftPacks = []);
      !data.storeCount && (data.storeCount = 0);
      !data.warehouseCount && (data.warehouseCount = 0);
      !data.isJit && (data.isJit = false);
    }
  }, {
    key: 'setGiftCampaignsModel',
    value: function setGiftCampaignsModel() {
      var _this2 = this;

      console.log('_allFromStore', this.data);
      this.campaignPacks = [];
      this.data.giftCampaigns && this.data.giftCampaigns.forEach(function (gift) {
        var giftCampaign = (0, _util.create)(_campaign2.default, gift);
        _this2.campaignPacks.push(giftCampaign);
      });
    }
  }, {
    key: 'modify',
    value: function modify(data) {
      return _promise2.default.resolve({});
    }
  }, {
    key: 'setAchieveMax',
    value: function setAchieveMax() {

      var spv = this.data.spv;
      if (spv.newcomerTag) {
        var max = spv.left;
        if (spv.quota) {
          max = Math.min(spv.left, spv.quota.left);
        }
        this.data.achieveMax = this.data.count >= max;
        if (this.data.achieveMax) {
          this.data.count = max;
        }
      } else {
        this.data.achieveMax = false;
      }
    }
  }, {
    key: 'emptyPreview',
    value: function emptyPreview() {
      this.data.giftPacks = [];
      this.data.labels = [];
      this.setLabelModel();
    }
    // resetDefault(data) {
    //   !data.labels && (data.labels = []);
    //   !data.giftPacks && (data.giftPacks = []);
    // }

    // resetGiftPacks (data) {
    //   const giftPacks = []
    //   const _giftPacksMap = {}
    //   data.giftPacks.forEach((g) => {
    //     if (g.groupId in giftPacksMap) {
    //       giftPacksMap[g.groupId].push(g)
    //     } else {
    //       giftPacksMap[g.groupId] = [g]
    //     }
    //     if (g.owned) {
    //       giftPacks.push(g)
    //     }
    //   })
    //   data.giftPacks = giftPacks
    //   data._giftPacksMap = _giftPacksMap
    // }

    // setLabelModel() {
    //   this.resetDefault()


    //   let Label = this.getLabelModel()
    //   this.labels = []
    //   this.data.labels.forEach((l) => {
    //     let label = create(Label, l, 'LABEL')
    //     this.labels.push(label)
    //   })
    //   this.data.giftPacks.forEach((l) => {
    //     let label = create(Label, l, 'GIFT')
    //     this.labels.push(label)
    //   })
    // }


  }]);
  return Pack;
}(_pack2.default);

exports.default = Pack;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/pack.js
// module id = 856
// module chunks = 0